"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUbCode = void 0;
// https://en.wikipedia.org/wiki/Universally_unique_identifier#Version_4_.28random.29
const ubCodeRegex = /[a-z0-9]{12}4[a-z0-9]{19}/;
function isUbCode(obj) {
    return ubCodeRegex.test(obj);
}
exports.isUbCode = isUbCode;
//# sourceMappingURL=is.js.map